import React from 'react';

type ShellHeaderAccentProps = {
  /** Slightly stronger AI accent for super-admin platform console. */
  variant?: 'default' | 'platform';
};

/** Lightweight edu + AI accent for the app header — ~15% of login scene intensity. */
export function ShellHeaderAccent({ variant = 'default' }: ShellHeaderAccentProps) {
  const isPlatform = variant === 'platform';

  return (
    <div
      className={`shell-accent${isPlatform ? ' shell-accent--platform' : ''}`}
      aria-hidden
    >
      <div className="shell-accent__sky" />
      <div className="shell-accent__orb shell-accent__orb--gold" />
      <div className="shell-accent__orb shell-accent__orb--cyan" />
      {isPlatform ? <div className="shell-accent__orb shell-accent__orb--violet" /> : null}
      <div className="shell-accent__hex" />
      <svg className="shell-accent__neural" viewBox="0 0 1200 80" preserveAspectRatio="none">
        <defs>
          <linearGradient id="shell-neural-line" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="rgba(120, 170, 200, 0)" />
            <stop offset="50%" stopColor="rgba(120, 170, 200, 0.18)" />
            <stop offset="100%" stopColor="rgba(140, 130, 180, 0)" />
          </linearGradient>
        </defs>
        <path
          d="M0 42 Q200 18 400 38 T800 32 T1200 48"
          fill="none"
          stroke="url(#shell-neural-line)"
          strokeWidth="1"
          className="shell-accent__neural-path"
        />
        <circle cx="200" cy="38" r="2.5" className="shell-accent__node" />
        <circle cx="480" cy="28" r="2" className="shell-accent__node" style={{ animationDelay: '0.5s' }} />
        <circle cx="760" cy="36" r="2.5" className="shell-accent__node" style={{ animationDelay: '1s' }} />
        <circle cx="980" cy="44" r="2" className="shell-accent__node" style={{ animationDelay: '1.5s' }} />
      </svg>
      <div className="shell-accent__shine" />
    </div>
  );
}
